import { isObjectEmpty } from '@/utils/campaignUtils';
import { useConfig } from '@travelwin/core';
import { captureError } from '../monitoring/sentry';

type ClientMarketingConsent = {
  enabled: boolean;
  legalUrl1: string | null;
  legalUrl2: string | null;
};

export const useClientMarketingConsent = () => {
  const { CLIENT_MARKETING_CONSENT } = useConfig();

  const parseClientMarketingConsent = (
    consent: string,
  ): ClientMarketingConsent | undefined => {
    try {
      const params = JSON.parse(consent);
      if (params && !isObjectEmpty(params)) {
        return params as ClientMarketingConsent;
      }
    } catch (error) {
      captureError(error);
      return undefined;
    }

    return undefined;
  };

  const clientMarketingConsent = parseClientMarketingConsent(
    CLIENT_MARKETING_CONSENT,
  );

  return { clientMarketingConsent };
};
